export default "__VITE_ASSET__CKEP0FET__"